import "./privacyPolicy.scss";

const PrivacyPolicy = () => {
    return (
        <div className="privacy-hero">
            <h1> Privacy & Cookies Policy</h1>

            <p>
                <br />
                <br />
            </p>
            <h2>PRIVACY POLICY</h2>
            <p>
                <br />
                <br />
                We are committed to protecting your privacy. This policy sets
                out the basis for the way in which your information is collected
                and processed by us. Please take a moment to read the following
                regarding your personal information and how we intend to treat
                it. We will make this information accessible on our homepage and
                everywhere that requests this personal data from you.
                <br />
                <br />
                We are fully compliant with GDPR (General Data Protection
                Regulation). We may collect and process the following data about
                you:
                <br />
                <br />
                Your name
                <br />
                Company name
                <br />
                Address
                <br />
                E-mail address
                <br />
                Phone number
                <br />
                <br />
                This applies to information collected or submitted on the
                Space website whether this by filling in forms or by
                corresponding with us by phone, e-mail or otherwise.
                <br />
                <br />
                <br />
                </p>
                <h2>
                COOKIE POLICY
                </h2>
                <p>
                <br />
                <br />
                We may automatically collect certain data from you as you use
                our website by using cookies and similar technologies.
                <br />
                <br />
                Our website uses cookies to distinguish you from other users of
                our website. A cookie is a small file of information stored on
                the hard drive of your computer which records the way in which
                you move around a website. These are used by nearly all websites
                and do not harm your system. They allow us to provide you with a
                good experience when browsing our website as well as tracking
                any patterns with your use of our website. This means we can
                improve our website to satisfy your needs and therefore respond
                correctly.
                <br />
                <br />
                You can set your browser to refuse all or some browser cookies,
                or to alert you when websites set or access cookies. Please not
                that some parts of our website may become inaccessible if you do
                this.
                <br />
                <br />
                How we use information:
                <br />
                <br />
                We use personal information held about you primarily for the
                purpose of your enquiry.
                <br />
                <br />
                We do not share this information with outside parties unless
                necessary to finish the enquiry in accordance with our
                instructions, requiring all to respect the security of your
                personal data and treat it in accordance with the law. This will
                not be shared in ways unrelated to the enquiry without your
                complete consent and you have the right to request for us not to
                process your personal data for any purposes.
                <br />
                <br />
                <br />
                </p>
                <h2>
                DATA SECURITY
                </h2>
                <p>
                <br />
                <br />
                We have put in place security measures to prevent your personal
                data from being accidentally lost, altered, disclosed, or
                accessed without being authorised. This personal data can be
                accessed only by employees and is kept confidential. All data is
                held on a password protected drive, and any data held on
                individual PCs or mobile devices is also password protected.
            </p>
        </div>
    );
};

export default PrivacyPolicy;
